import React from 'react';

const UnoSignaturContent = ({ product, sectionsRef }) => {
  return (
    <>
      {/* Hero Section */}
      <div
        ref={(el) => (sectionsRef.current[0] = el)}
        className="text-center mb-24"
      >
        <p className="text-sm tracking-[0.3em] uppercase mb-6" style={{ color: 'var(--atelier-gold)' }}>
          ATELIER RESERVE
        </p>
        <h1 className="text-6xl md:text-8xl font-light mb-8" style={{ color: 'var(--atelier-black)' }}>
          Uno Signatur
        </h1>
        <p className="text-xl md:text-2xl font-light italic max-w-3xl mx-auto" style={{ color: 'var(--atelier-grey)' }}>
          Puur. Intens. Onvergetelijk.
        </p>
      </div>

      {/* Product Image */}
      <div
        ref={(el) => (sectionsRef.current[1] = el)}
        className="max-w-2xl mx-auto mb-24"
      >
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-auto"
        />
      </div>

      {/* Het Verhaal */}
      <section
        ref={(el) => (sectionsRef.current[2] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-8" style={{ color: 'var(--atelier-black)' }}>
          Het Verhaal
        </h2>
        <div className="space-y-6 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
          <p className="text-xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Soms is minder meer.
          </p>
          <p>
            Terwijl Duo Penotti beroemd werd door twee smaken te combineren, vroegen wij ons af: 
            wat als we alle aandacht richten op één perfecte smaak? Geen compromissen. Geen balanceren. 
            Alleen de zuiverste expressie van hazelnoot en pure chocolade.
          </p>
          <p className="text-xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Uno Signatur is het antwoord.
          </p>
          <p>
            Dit is geen product voor iedereen. Dit is voor de puristen. Voor wie weet dat echte 
            intensiteit geen afleiding nodig heeft.
          </p>
        </div>
      </section>

      {/* De Oorsprong */}
      <section
        ref={(el) => (sectionsRef.current[3] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          De Oorsprong
        </h2>

        <div>
          <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
            Piemonte, Italië
          </h3>
          <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
            <p>
              Er is maar één plek ter wereld waar hazelnoten groeien zoals ze bedoeld zijn.
            </p>
            <p>
              De glooiende heuvels van Piemonte, genesteld tussen de Alpen en de Middellandse Zee, 
              bieden een microklimaat dat nergens anders bestaat. Koele nachten. Warme dagen. 
              Mineraalrijke bodem van eeuwenoude rivierafzettingen.
            </p>
            <p>
              Hier groeit de <em>Tonda Gentile delle Langhe</em> — officieel erkend als 's werelds beste hazelnoot. 
              Rond. Compact. Met een oliegehalte dat perfect roostert zonder bitter te worden.
            </p>
            <p>
              Wij kopen direct van drie familiekwekerijen die al generaties deze noten verbouwen. 
              Geen tussenhandel. Geen menging met inferieure variëteiten.
            </p>
            <p className="text-2xl font-light mt-6" style={{ color: 'var(--atelier-gold)' }}>
              100% Piemonte. 100% Tonda Gentile.
            </p>
          </div>
        </div>
      </section>

      {/* De Ingrediënten */}
      <section
        ref={(el) => (sectionsRef.current[4] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          De Ingrediënten
        </h2>

        <div className="space-y-12">
          {/* Single-Origin Hazelnoten */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Single-Origin Hazelnoten
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Geoogst in de drie weken tussen eind augustus en half september — het smalle venster waarin 
                de noten hun optimale rijpheid bereiken. Eerder geplukt missen ze diepte. Later geoogst 
                verliezen ze frisheid.
              </p>
              <p>
                Onze noten worden dezelfde dag nog getransporteerd naar de verwerkingsfaciliteit. Binnen 
                48 uur zijn ze gedopt, gesorteerd en klaar voor roostering.
              </p>
              <p className="text-xl font-light italic" style={{ color: 'var(--atelier-gold)' }}>
                Versheid die je proeft.
              </p>
            </div>
          </div>

          {/* Pure Chocolade */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Pure Chocolade
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Geen melkchocolade. Geen compromis.
              </p>
              <p>
                Onze single-origin cacao komt van één plantage, wat zorgt voor een consistente smaakprofilering 
                die jaar na jaar herkenbaar is. Intens, licht bitter, met tonen van rode vrucht en een lange afdronk.
              </p>
              <p className="text-xl font-light" style={{ color: 'var(--atelier-black)' }}>
                70% cacao. Rainforest Alliance gecertificeerd.
              </p>
            </div>
          </div>

          {/* Ruwe Rietsuiker */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Ruwe Rietsuiker
            </h3>
            <p className="text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              Minimaal, maar essentieel. Ongeraffineerde rietsuiker voegt net genoeg zoetheid toe om de 
              bitterheid te balanceren, zonder de hazelnoot te overschaduwen. De lichte karameltonen 
              complementeren het roosterproces.
            </p>
          </div>
        </div>
      </section>

      {/* Het Proces */}
      <section
        ref={(el) => (sectionsRef.current[5] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Het Proces
        </h2>

        <div className="space-y-12">
          {/* De Perfecte Roost */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              De Perfecte Roost
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Roosteren is waar hazelnootpasta wordt gemaakt of gebroken.
              </p>
              <p>
                Industriële producenten roosteren bij hoge temperatuur voor snelheid. Wij roosteren langzaam — 
                22 minuten bij 145°C — waardoor de noten gelijkmatig kleuren en hun natuurlijke oliën vrijkomen 
                zonder te verbranden.
              </p>
              <p className="text-xl font-light italic" style={{ color: 'var(--atelier-black)' }}>
                Het resultaat: een diepere, complexere smaak. Geen bittere ondertoon.
              </p>
            </div>
          </div>

          {/* Stone-Ground */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Stone-Ground
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Na het roosteren worden de noten vermalen op granieten molenstenen. Geen moderne staalmolens 
                die hitte genereren en smaak vernietigen. Het traditionele proces duurt langer, maar behoudt 
                elke nuance.
              </p>
              <p className="text-2xl font-light" style={{ color: 'var(--atelier-gold)' }}>
                72 uur malen. Voor de perfecte textuur.
              </p>
            </div>
          </div>

          {/* Concheren */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Concheren
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Het laatste geheim. Na het malen wordt de pasta urenlang 'geconcheerd' — een proces waarbij 
                lucht en warmte de ruwe randen wegnemen en de smaken laten samensmelten.
              </p>
              <div className="bg-white/50 p-6 rounded">
                <p className="text-lg mb-2">Industrieel: 4-6 uur.</p>
                <p className="text-lg mb-4">Uno Signatur: 24 uur.</p>
                <p className="text-xl font-light italic" style={{ color: 'var(--atelier-gold)' }}>
                  Het verschil is fluweelzacht.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proefnotities */}
      <section
        ref={(el) => (sectionsRef.current[6] = el)}
        className="max-w-4xl mx-auto mb-24 bg-white/50 p-12 rounded"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Proefnotities
        </h2>

        <div className="space-y-6">
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Aroma
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              Direct bij openen — intense geroosterde hazelnoot, gevolgd door diepe cacaotonen.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Eerste hap
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              De hazelnoot domineert. Warm, nootachtig, met een subtiele zoetheid.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Ontwikkeling
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              De chocolade ontvouwt zich langzaam. Bitter maar niet scherp. Tonen van kersen en tabak.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Textuur
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              Dichter dan Duo Signatur. Romig maar met body. Smelt traag en luxueus.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Afdronk
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              Uitzonderlijk lang. De hazelnoot keert terug, nu met een vleugje espresso.
            </p>
          </div>
        </div>
      </section>

      {/* Voor de Puristen */}
      <section
        ref={(el) => (sectionsRef.current[7] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Voor de Puristen
        </h2>

        <div className="space-y-8">
          <div>
            <p className="text-xl leading-relaxed mb-6" style={{ color: 'var(--atelier-grey)' }}>
              Uno Signatur vraagt om eenvoud.
            </p>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Het Ultieme Moment
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Vers brood van de bakker. Nog warm. Niets erop behalve een royale laag Uno Signatur. 
                Laat de pasta even op kamertemperatuur komen voor optimale smeerbaarheid.
              </p>
              <p className="text-xl font-light italic" style={{ color: 'var(--atelier-gold)' }}>
                Sluit je ogen. Proef.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Voor de Avonturiers
            </h3>
            <ul className="space-y-2 text-lg" style={{ color: 'var(--atelier-grey)' }}>
              <li>• Door verse pasta als luxueuze saus</li>
              <li>• Gesmolten over vanille-ijs</li>
              <li>• Als basis voor huisgemaakte pralines</li>
              <li>• Bij een glas Barolo — de wijn uit dezelfde regio</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Waarom Reserve */}
      <section
        ref={(el) => (sectionsRef.current[8] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-8" style={{ color: 'var(--atelier-black)' }}>
          Waarom Reserve?
        </h2>
        <div className="space-y-6 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
          <p>
            De Atelier Reserve-lijn is ons statement van wat mogelijk is zonder budgetbeperkingen.
          </p>
          <p>
            Uno Signatur kost meer om te maken dan welk ander product in ons assortiment. De hazelnoten alleen 
            zijn drie keer duurder dan standaard. Het langzame proces verlaagt onze output. De single-origin 
            chocolade kent prijsschommelingen die we accepteren in plaats van te compenseren met goedkopere 
            alternatieven.
          </p>
          <p className="text-xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Dit is geen product voor de massa.<br />
            Dit is voor wie het verschil proeft. En waardeert.
          </p>
        </div>
      </section>

      {/* Specificaties */}
      <section
        ref={(el) => (sectionsRef.current[9] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Specificaties
        </h2>

        <div className="bg-white/50 p-8 rounded">
          <table className="w-full">
            <tbody className="space-y-4">
              {[
                ['Inhoud', '300g'],
                ['Hazelnoten', '100% Piemonte Tonda Gentile'],
                ['Chocolade', '70% single-origin, RA-gecertificeerd'],
                ['Suiker', 'Ongeraffineerde rietsuiker'],
                ['Roostertijd', '22 minuten bij 145°C'],
                ['Maaltijd', '72 uur stone-ground'],
                ['Concheren', '24 uur'],
                ['Productie', 'Roosendaal, Nederland'],
                ['Bewaaradvies', 'Op kamertemperatuur, na openen binnen 6 weken'],
              ].map(([key, value]) => (
                <tr key={key} className="border-b border-gray-200">
                  <td className="py-4 text-lg font-light" style={{ color: 'var(--atelier-black)' }}>
                    {key}
                  </td>
                  <td className="py-4 text-lg text-right" style={{ color: 'var(--atelier-grey)' }}>
                    {value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* De Essentie */}
      <section
        ref={(el) => (sectionsRef.current[10] = el)}
        className="max-w-4xl mx-auto mb-24 text-center"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mx-auto mb-12" />
        <div className="space-y-6 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
          <p className="text-2xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Duo Signatur is een meesterwerk van balans.
          </p>
          <p className="text-2xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Uno Signatur is een meesterwerk van focus.
          </p>
          <p className="text-xl mt-8">
            Geen vanille om te verzachten. Geen tweede kleur om af te leiden. Alleen hazelnoot en chocolade, 
            in hun meest pure, intense vorm.
          </p>
          <p className="text-xl font-light italic mt-8" style={{ color: 'var(--atelier-gold)' }}>
            Voor sommigen te veel.<br />
            Voor kenners precies goed.
          </p>
        </div>

        <div className="mt-16">
          <p className="text-xl font-light italic mb-6" style={{ color: 'var(--atelier-grey)' }}>
            "Perfectie is niet wanneer er niets meer toe te voegen is. Perfectie is wanneer er niets meer weg te laten is."
          </p>
          <p className="text-2xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Uno Signatur. Pure Essentie.
          </p>
        </div>
      </section>
    </>
  );
};

export default UnoSignaturContent;
